    import { useState } from 'react';

    const Footer = () => {
    return (
        <footer className="bg-dark text-white py-1 mt-0">
        <div className="container text-center mt-2">
            <p>Yasserv©copyright. Todos os direitos reservados.</p>
        </div>
        </footer>
    );
    };

    export default Footer;